import { useTranslation } from 'react-i18next'

import { getDateFnsLocale } from '@app/helpers'

import { Loader } from '@lib/components'

import { SafeIndicator } from './SafeIndicator'
import { SpamIndicator } from './SpamIndicator'
import { getCategoryClass, formatDate, HistoryItem } from './helpers'
import styles from './styles.module.scss'

export const SpamReport = ({
  isSafe,
  loading,
  historyItems,
}: {
  isSafe: boolean
  loading: boolean
  historyItems: HistoryItem[]
}) => {
  const { t, i18n } = useTranslation()
  const locale = getDateFnsLocale(i18n.language)

  if (loading) {
    return (
      <div className={styles.spamReport}>
        <Loader />
      </div>
    )
  }
  return (
    <>
      <div className={styles.spamReport}>
        <div className={styles.status}>
          {isSafe ? <SafeIndicator /> : <SpamIndicator />}
        </div>
        <div className={styles.history}>
          <h4>{t('Chat.Message.SpamReport.SpamCheckHistory')}</h4>
          {historyItems.length == 0 && !loading && (
            <div>{t('Chat.Message.SpamReport.NoSpamChecksFound')}</div>
          )}
          {historyItems.length > 0 && (
            <div className={styles.historyHeader}>
              <div className={styles.colDate}>
                {t('Chat.Message.SpamReport.History.Date')}
              </div>
              <div className={styles.colDetection}>
                {t('Chat.Message.SpamReport.History.Detection')}
              </div>
              <div className={styles.colReason}>
                {t('Chat.Message.SpamReport.History.ReasonUser')}
              </div>
              <div className={styles.colResult}>
                {t('Chat.Message.SpamReport.History.Result')}
              </div>
            </div>
          )}
          {historyItems.map(({ event, reasons }) =>
            reasons.length > 0 ? (
              reasons.map((reason, index) => (
                <div
                  className={styles.historyItem}
                  key={`${event.id}-${index}`}
                >
                  <div className={styles.colDate}>
                    {formatDate(event.creationDate, locale)}
                  </div>
                  <div className={styles.colDetection}>{reason.source}</div>
                  <div className={styles.colReason}>{reason.reason}</div>
                  <div className={styles.colSummaryMobile}>
                    <div>
                      {reason.source}
                      {reason.reason ? ': ' : ''}
                      {reason.reason}
                    </div>
                    <div className={styles.colDate}>
                      {formatDate(event.creationDate, locale)}
                    </div>
                  </div>
                  <div className={styles.colResult}>
                    <span
                      className={getCategoryClass(
                        reason.category,
                        reason.source,
                        styles
                      )}
                    >
                      {t(`Chat.Message.SpamReport.Status.${reason.category}`)}
                    </span>
                  </div>
                </div>
              ))
            ) : (
              <div className={styles.historyItem} key={`${event.id}-empty`}>
                <div className={styles.colDate}>
                  {formatDate(event.creationDate, locale)}
                </div>
                <div className={styles.colDetection}></div>
                <div className={styles.colReason}></div>
                <div className={styles.colResult}>
                  <span className={styles.safe}>
                    {t('Chat.Message.SpamReport.Status.Safe')}
                  </span>
                </div>
              </div>
            )
          )}
        </div>
      </div>
    </>
  )
}
